import React from "react";
import Panel from "../Common/Components/Panel.jsx";
import NewsFeedContainer from "./NewsFeedContainer";
import {FormattedMessage} from "react-intl";

const NewsFeedPanel = ({sport}) => {
    if (sport !== 'darts' && sport!=='tennis'  && sport!=='cycling' && sport!=='cyclocross') {
        return null;
    }

    return <FormattedMessage id="newsFeed.title">{message =>
        <Panel name={message}>
            <NewsFeedContainer sport={sport}/>
        </Panel>}
    </FormattedMessage>;
};

export default NewsFeedPanel